import { Flex } from '@radix-ui/themes'
import { formatValue } from './claim-form-utils'
import { FieldRow } from './claim-form-fields'
import { CONTACT_ROWS, getFieldLabel } from './claim-form-constants'

export function ContactFields({
  data,
  formData,
}: {
  data: Record<string, unknown>
  formData?: Record<string, unknown>
}) {
  const claimant = (formData?.claimant ?? {}) as { usCitizen?: boolean }
  const isUS = claimant.usCitizen !== false
  const regionLabel = isUS ? 'State' : 'Province/Region'

  const labelFor = (field: string) => (field === 'region' ? regionLabel : getFieldLabel(field))

  return (
    <Flex direction="column" gap="3">
      {CONTACT_ROWS.map(([left, right]) => (
        <div key={left} className="claim-form-two-col">
          <FieldRow label={labelFor(left)} value={formatValue(data[left])} />
          {right ? <FieldRow label={labelFor(right)} value={formatValue(data[right])} /> : <div />}
        </div>
      ))}
    </Flex>
  )
}
